import { DuplaAutenticacaoTipo } from "./credential";

export class Login {
  hashConta: string;
  login: string;
  senha: string;
  clientId: string;
  codigo:string;
  duplaAutenticacaoTipo:DuplaAutenticacaoTipo;
}
